// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.TopNavRightBox_topNavBox_right__BBI2W {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex: 1 1;
}
@media screen and (max-width: 975px) {
  .TopNavRightBox_topNavBox_right__BBI2W {
    flex: 2 1;
  }
}
@media screen and (max-width: 325px) {
  .TopNavRightBox_topNavBox_right__BBI2W {
    flex-wrap: wrap;
  }
}

.TopNavRightBox_wrapper__9f9q4 {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
@media screen and (max-width: 975px) {
  .TopNavRightBox_wrapper__9f9q4 {
    justify-content: space-evenly;
  }
}
@media screen and (max-width: 325px) {
  .TopNavRightBox_wrapper__9f9q4 {
    order: 2;
    margin-top: 0.5rem;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/topnav/rightBox/TopNavRightBox.module.scss","webpack://./src/scss/abstracts/_variables.scss","webpack://./src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EECE,aAAA;EACA,mBFDc;EEEd,6BFFsB;EACtB,SAAA;AASF;AARE;EAHF;IAII,SAAA;EAWF;AACF;AAVE;EANF;IAOI,eAAA;EAaF;AACF;;AAXA;EACE,SAAA;EEVA,aAAA;EACA,mBFUc;EETd,yBFSsB;AAgBxB;AAfE;EAHF;IAII,6BAAA;EAkBF;AACF;AAjBE;EANF;IAOI,QAAA;IACA,kBAAA;IACA,8BAAA;EAoBF;AACF","sourcesContent":["@use \"../../../scss/abstracts/\" as *;\r\n\r\n.topNavBox_right {\r\n  @include flex(center, space-evenly);\r\n  flex: 1;\r\n  @media screen and (max-width: 975px) {\r\n    flex: 2;\r\n  }\r\n  @media screen and (max-width: 325px) {\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n.wrapper {\r\n  flex: 1;\r\n  @include flex(center, flex-end);\r\n  @media screen and (max-width: 975px) {\r\n    justify-content: space-evenly;\r\n  }\r\n  @media screen and (max-width: 325px) {\r\n    order: 2;\r\n    margin-top: 0.5rem;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n","@use './variables' as *;\r\n\r\n@mixin flex($alignItem: center, $justifyContent: center) {\r\n  display: flex;\r\n  align-items: $alignItem;\r\n  justify-content: $justifyContent;\r\n}\r\n\r\n@mixin mobile {\r\n  @media only screen and (max-width: $mobile-width) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n  @media only screen and (max-width: $tablet-width) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topNavBox_right": `TopNavRightBox_topNavBox_right__BBI2W`,
	"wrapper": `TopNavRightBox_wrapper__9f9q4`
};
export default ___CSS_LOADER_EXPORT___;
